import shared from "../data/js/shared";
import Link from "next/link";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useRouterContext } from "../contexts";

const { sellProductLabel, marketplaceLabel } = shared.product;

interface MobileTopNavProps {
	state: string;
	setMobileTopNav: (position: string) => void;
	setLoginOpen: (open: boolean) => void;
	setProductOpen: (open: boolean) => void;
	removeProduct: () => void;
}

const MobileTopNav = ({
	state: _state,
	setMobileTopNav,
	setLoginOpen: _setLoginOpen,
	setProductOpen: _setProductOpen,
	removeProduct: _removeProduct,
}: MobileTopNavProps) => {
	const [isClient, setIsClient] = useState(false);
	const { pathname, push } = useRouterContext();

	// Determine current nav position based on route
	const isOnSellPage = pathname.includes('/sell');
	const currentPosition = isOnSellPage ? 'right' : 'left';

	// Set client side after mount
	useEffect(() => {
		// eslint-disable-next-line react-hooks/set-state-in-effect -- intentional post-mount client flag gating the client-only framer-motion slider to avoid SSR hydration mismatch
		setIsClient(true);
	}, []);

	useEffect(() => {
		// Update position when route changes
		if (setMobileTopNav) {
			setMobileTopNav(currentPosition);
		}
	}, [pathname, currentPosition, setMobileTopNav]);

	return (
		<div className="mobile-nav mobile-top-nav">
			{/* Blue slider indicator - draggable with framer-motion */}
			{isClient && (
				<motion.div
					className="slider"
					drag="x"
					dragMomentum={false}
					dragElastic={0.2}
					dragConstraints={{ left: 0, right: 80 }}
					animate={{ x: currentPosition === 'right' ? 75 : 0 }}
					transition={{ type: "spring", stiffness: 300, damping: 30 }}
					onDragEnd={(_event, info) => {
						// Navigate if dragged past midpoint (60px)
						const midpoint = 60;
						const offset = info.offset.x;

						// If currently on left (marketplace) and dragged right past midpoint
						if (currentPosition === 'left' && offset > midpoint) {
							push('/sell');
							if (setMobileTopNav) { setMobileTopNav('right'); }
						}
						// If currently on right (sell) and dragged left past midpoint
						else if (currentPosition === 'right' && offset < -midpoint) {
							push('/');
							if (setMobileTopNav) { setMobileTopNav('left'); }
						}
					}}
				/>
			)}
			<Link
				href="/"
				className="slider-left"
				onClick={() => {
					setMobileTopNav("left");
				}}
			>
				{marketplaceLabel}
			</Link>
			<Link
				href="/sell"
				className="slider-right"
				onClick={() => {
					setMobileTopNav("right");
				}}
			>
				{sellProductLabel}
			</Link>
		</div>
	);
};

export default MobileTopNav;
